import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { btlApplicationFormApi } from '@api/btlApplicationForm/btlApplicationFormApi';
import { Conveyancing } from '@api/btlApplicationForm/conveyancingTypes';

export const useConveyancing = (applicationId?: string | number): UseQueryResult<Conveyancing | null> => {
  const isMigrated = typeof applicationId === 'string';

  return useQuery(
    ['conveyancing', applicationId],
    () => (isMigrated ? btlApplicationFormApi.getConveyancing(applicationId) : null),
    {
      enabled: isMigrated,
      retry: false,
    },
  );
};
